const FUEL_EVENTS = {
    REFUEL: 'REFUEL',
    THEFT: 'THEFT'
}

const EVENT_TYPES = {
    ALL: "ALL",
    INFO: 0,
    WARNING: 1,
    CRITICAL: 2,
    CONTROL: "CONTROL"
};

export const EVENT_TYPES_TITLE = {
    [EVENT_TYPES.ALL]: {
        label: 'ALL',
        color: "#C4C4C4"
    },
    [EVENT_TYPES.INFO]: {
        label: 'INFO',
        color: "#52C41A"
    }, //old color: #37c837
    [EVENT_TYPES.WARNING]: {
        label: 'WARNING',
        color: "#FFB517"
    }, //old color: #7F2AFF
    [EVENT_TYPES.CRITICAL]: {
        label: 'CRITICAL',
        color: "#0488DB"
    }, //old color: #D4FF2A
    [EVENT_TYPES.CONTROL]: {
        label: 'CONTROL',
        color: "#856B37"
    } //old color: #2A2AFF
};

export const MDVR_TYPES_TITLE = {
    'Video': 'Video',
    'Snapshot': 'Snapshot'
}

export {
    FUEL_EVENTS
}